import {
  MainPhotoSection,
  WebTerminalSection,
  HowToStartSection,
} from "../../MainPage/MainPageStyles";
import { TermsCardsSection } from "../../TermsPage/TermsPageStyles";
import { InvestSection } from "../../MainPage/MainPageStyles";
import { TerminalMain } from "./TradingTerminalStyles";
import TerminalMainPhoto from "../../../images/terminalMainPhoto.png";
import { NavLink } from "react-router-dom";
import WebTerminal from "../../../images/webTerminalPhoto.png";
import { MStartTraidingCard } from "../../../components/Cards/StartTraidingCard/StartTraidingCard";
import StartTradingFirstImg from "../../../images/CardsImages/StartCardImages/firstCard1.png";
import StartTradingSecondImg from "../../../images/CardsImages/StartCardImages/secondCard.png";
import firstCardIcon from "../../../images/CardsImages/TermsCardIcons/speedIcon.svg";
import secondCardIcon from "../../../images/CardsImages/TermsCardIcons/security.svg";
import thirdCardIcon from "../../../images/CardsImages/TermsCardIcons/developmentIcon.svg";
import fourthCardIcon from "../../../images/CardsImages/TermsCardIcons/levelIcon.svg";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
} from "../../../animations/animations";
import { MTermsCard } from "../../../components/Cards/TermsCard/TermsCard";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { generateLink } from "../../../functions/routingFuntion";

export const TradingTerminal = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <TerminalMain>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("tradingTerminalPage.title1")}</h1>
            <p className="big__text">{t("tradingTerminalPage.title2")}</p>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={TerminalMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <TermsCardsSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("tradingTerminalPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="flex__between terms-cards__container"
          >
            <MTermsCard
              img={secondCardIcon}
              title={`${t("tradingTerminalPage.blockInfo11")}`}
              custom={1}
              variants={arrAnimation}
            />
            <MTermsCard
              img={thirdCardIcon}
              title={`${t("tradingTerminalPage.blockInfo12")}`}
              custom={2}
              variants={arrAnimation}
            />
            <MTermsCard
              img={firstCardIcon}
              title={`${t("tradingTerminalPage.blockInfo13")}`}
              custom={3}
              variants={arrAnimation}
            />
            <MTermsCard
              img={fourthCardIcon}
              title={`${t("tradingTerminalPage.blockInfo14")}`}
              custom={4}
              variants={arrAnimation}
            />
          </motion.div>
        </div>
      </TermsCardsSection>
      <InvestSection className="border">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("tradingTerminalPage.blockInfo2Tit")}</h2>
            <p className="big__text">{t("tradingTerminalPage.blockInfo21")}</p>
            <ul>
              <li>{t("tradingTerminalPage.blockInfo2li1")}</li>
              <li>{t("tradingTerminalPage.blockInfo2li2")}</li>
              <li>{t("tradingTerminalPage.blockInfo2li3")}</li>
              <li>{t("tradingTerminalPage.blockInfo2li4")}</li>
              <li>{t("tradingTerminalPage.blockInfo2li5")}</li>
            </ul>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/login", language)}
            >
              {t("tradingTerminalPage.blockInfo22")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </InvestSection>
      <WebTerminalSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between row__reverse"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("tradingTerminalPage.blockInfo3Tit")}</h2>
            <p className="big__text">{t("tradingTerminalPage.blockInfo31")}</p>
            <p>{t("tradingTerminalPage.blockInfo32")}</p>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </WebTerminalSection>
      <HowToStartSection
        style={{
          background: "#074275",
          margin: "30px 0px",
        }}
      >
        <div className="container__standart trading__together">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("tradingTerminalPage.blockInfo4Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            className="flex__between cards__container"
          >
            <MStartTraidingCard
              custom={1}
              variants={arrAnimation}
              title="1"
              img={`${StartTradingFirstImg}`}
              text={`${t("tradingTerminalPage.blockInfo41")}`}
            />
            <div className="middle">
              <MStartTraidingCard
                custom={2}
                variants={arrAnimation}
                title="2"
                text={`${t("tradingTerminalPage.blockInfo42")}`}
                imgDisplay="none"
              />
              <MStartTraidingCard
                custom={3}
                variants={arrAnimation}
                title="3"
                text={`${t("tradingTerminalPage.blockInfo43")}`}
                imgDisplay="none"
              />
            </div>
            <MStartTraidingCard
              custom={4}
              variants={arrAnimation}
              title="4"
              img={`${StartTradingSecondImg}`}
              text={`${t("tradingTerminalPage.blockInfo44")}`}
            />
          </motion.div>
          <NavLink
            to={generateLink("/auth/login", language)}
            className="white__button flex__center"
          >
            {t("tradingTerminalPage.blockInfo45")}
          </NavLink>
        </div>
      </HowToStartSection>
      <WebTerminalSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("tradingTerminalPage.blockInfo5Tit")}</h2>
            <NavLink
              to={generateLink("/auth/register", language)}
              className="white__button flex__center"
            >
              {t("tradingTerminalPage.blockInfo51")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </WebTerminalSection>
    </TerminalMain>
  );
};
